if (!window.__phylumDesertDreaming) {
window.__phylumDesertDreaming = true;
document.documentElement.classList.add('phylum-dd-on');

    const clearHeader = () => {
      const root = document.querySelector('.phylum-dd');
      if (!root) return;
      root.style.paddingTop = '0px';
      let bottom = 0;
      document.querySelectorAll('header, .announcement-bar, .announcement, #shopify-section-header, #shopify-section-announcement-bar').forEach((el) => {
        const style = getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden') return;
        const rect = el.getBoundingClientRect();
        if (rect.bottom > bottom && rect.top < 80 && rect.height > 0 && rect.height < 220) bottom = rect.bottom;
      });
      root.style.paddingTop = '0px';
      document.documentElement.style.setProperty('--dd-stick', Math.ceil((bottom || 78) + 8) + 'px');
    };
    clearHeader();
    window.addEventListener('resize', clearHeader);


  (function () {
    const root = document.documentElement;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const fitDateBand = () => {
      const text = document.querySelector('.dd-seal-date textPath');
      const band = document.querySelector('.dd-date-band');
      if (!text || !band) return;
      const len = text.getComputedTextLength();
      if (!len) return;
      const R = 128;
      const cap = 15.5 * 0.7;
      const pad = 2.5;
      const corner = 2;
      const rOut = R + cap + pad;
      const rIn = R - pad;
      const a0 = -25 * Math.PI / 180;
      const along = 2.2;
      let endLen = len;
      const n = text.getNumberOfChars();
      if (n > 1) {
        try {
          const end = text.getEndPositionOfChar(n - 1);
          let a = Math.atan2(end.x - 100, 100 - end.y);
          while (a < a0 - 0.2) a += Math.PI * 2;
          const alongArc = (a - a0) * R;
          if (alongArc > endLen) endLen = alongArc;
        } catch (e) {}
      }
      const aStart = a0 - along / R;
      const aEnd = a0 + (endLen + 2.4) / R;
      const pt = (r, a) => `${(100 + r * Math.sin(a)).toFixed(2)},${(100 - r * Math.cos(a)).toFixed(2)}`;
      const betaO = Math.asin(Math.min(0.99, corner / (rOut - corner)));
      const betaI = Math.asin(Math.min(0.99, corner / (rIn + corner)));
      const o0 = aStart + betaO;
      const o1 = aEnd - betaO;
      const i0 = aStart + betaI;
      const i1 = aEnd - betaI;
      const large = (o1 - o0) > Math.PI ? 1 : 0;
      const rayOut = (rOut - corner) * Math.cos(betaO);
      const rayIn = (rIn + corner) * Math.cos(betaI);
      band.setAttribute('d', [
        `M ${pt(rOut, o0)}`,
        `A ${rOut.toFixed(2)},${rOut.toFixed(2)} 0 ${large},1 ${pt(rOut, o1)}`,
        `A ${corner},${corner} 0 0,1 ${pt(rayOut, aEnd)}`,
        `L ${pt(rayIn, aEnd)}`,
        `A ${corner},${corner} 0 0,1 ${pt(rIn, i1)}`,
        `A ${rIn.toFixed(2)},${rIn.toFixed(2)} 0 ${large},0 ${pt(rIn, i0)}`,
        `A ${corner},${corner} 0 0,1 ${pt(rayIn, aStart)}`,
        `L ${pt(rayOut, aStart)}`,
        `A ${corner},${corner} 0 0,1 ${pt(rOut, o0)}`,
        'Z'
      ].join(' '));
    };
    fitDateBand();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitDateBand);
    window.addEventListener('resize', fitDateBand);

    const ticker = document.querySelector('.dd-ticker-track');
    if (ticker) ticker.appendChild(ticker.firstElementChild.cloneNode(true)).setAttribute('aria-hidden', 'true');

    const peek = document.querySelector('.dd-peek');
    if (ticker && peek && window.matchMedia('(hover: hover)').matches) {
      const peekImg = peek.querySelector('.dd-peek-img');
      const peekNote = peek.querySelector('.dd-peek-note');
      const peekLabel = peek.querySelector('.dd-peek-cta-label');
      const peekCta = peek.querySelector('.dd-peek-cta');
      const tickerBand = ticker.closest('.dd-ticker');
      const pos = { x: 0, y: 0 };
      const aim = { x: 0, y: 0 };
      let current = null;
      let raf = null;
      let hideTimer = null;
      let onCta = false;
      let anchorY = null;
      let tiltNow = 0;

      ticker.querySelectorAll('[data-peek]').forEach(item => { new Image().src = item.dataset.peek; });

      const pointerInActiveZone = (x, y) => {
        if (!current || !peek.classList.contains('is-on')) return false;
        const padX = 28;
        const padY = 20;
        const pr = peek.getBoundingClientRect();
        const ir = current.getBoundingClientRect();
        const left = Math.min(pr.left, ir.left) - padX;
        const right = Math.max(pr.right, ir.right) + padX;
        const top = Math.min(pr.top, ir.top) - padY;
        const bottom = Math.max(pr.bottom, ir.bottom) + padY;
        return x >= left && x <= right && y >= top && y <= bottom;
      };

      const follow = () => {
        pos.x += (aim.x - pos.x) * 0.16;
        pos.y += (aim.y - pos.y) * 0.2;
        const tiltTarget = onCta ? 0 : Math.max(-8, Math.min(8, (aim.x - pos.x) * 0.05));
        tiltNow += (tiltTarget - tiltNow) * 0.22;
        peek.style.transform = `translate(${pos.x - peek.offsetWidth / 2}px, ${pos.y - peek.offsetHeight}px) rotate(${tiltNow}deg)`;
        raf = current ? requestAnimationFrame(follow) : null;
      };

      // Sit the card above the name when it fits. Near the top of the screen that
      // would land off the page, so it drops below the name instead.
      const anchorTo = (item, x, lockY = false) => {
        const r = item.getBoundingClientRect();
        const cardW = peek.offsetWidth || 300;
        const cardH = peek.offsetHeight || 240;
        const half = cardW / 2 + 16;
        aim.x = Math.min(window.innerWidth - half, Math.max(half, x));
        if (lockY && anchorY != null) return;
        const above = r.top - 8;
        const below = r.bottom + 8 + cardH;
        anchorY = above - cardH < 8 ? below : above;
        aim.y = anchorY;
      };

      const show = (item, x) => {
        clearTimeout(hideTimer);
        peek.classList.remove('is-dismissing');
        const wasOn = Boolean(current);
        current = item;
        anchorTo(item, x);
        if (!wasOn) { pos.x = aim.x; pos.y = aim.y; }
        const soon = item.hasAttribute('data-peek-soon');
        const shoppable = !soon && item.tagName === 'A' && item.hasAttribute('href');
        peek.classList.toggle('is-soon', soon);
        peekCta.hidden = !shoppable;
        const note = (item.dataset.note || '').trim();
        if (peekNote) {
          peekNote.hidden = !note;
          if (!peekNote.hidden) peekNote.textContent = note;
        }
        if (shoppable) {
          peekLabel.textContent = `Shop ${item.firstChild.textContent.trim()}`;
          peekCta.href = item.href;
          if (/^\//.test(item.getAttribute('href') || '')) {
            peekCta.removeAttribute('target');
            peekCta.removeAttribute('rel');
          } else {
            peekCta.target = '_blank';
            peekCta.rel = 'noopener';
          }
        }
        if (!soon && peekImg.getAttribute('src') !== item.dataset.peek) {
          if (wasOn) {
            peek.classList.add('is-swap');
            setTimeout(() => peek.classList.remove('is-swap'), 120);
          }
          peekImg.src = item.dataset.peek;
        }
        peek.classList.add('is-on');
        tickerBand.classList.add('is-peeking');
        window.setTimeout(() => peek.classList.add('is-engaged'), 380);
        if (!raf) raf = requestAnimationFrame(follow);
      };

      const HIDE_FADE_MS = 170;

      const hide = () => {
        current = null;
        onCta = false;
        anchorY = null;
        tiltNow = 0;
        peek.classList.remove('is-on', 'is-dismissing', 'is-engaged');
        tickerBand.classList.remove('is-peeking');
      };

      const keepPeekActive = (x, clientY) => {
        clearTimeout(hideTimer);
        peek.classList.remove('is-dismissing');
        anchorTo(current, x, true);
        if (!raf) raf = requestAnimationFrame(follow);
      };

      const overActiveZone = (node) => {
        if (!node || !node.closest) return false;
        if (node === peekCta || peekCta.contains(node)) return true;
        return Boolean(node.closest('.dd-ticker-item'));
      };

      const scheduleHide = () => {
        clearTimeout(hideTimer);
        if (!current || onCta || peek.classList.contains('is-dismissing')) return;
        peek.classList.add('is-dismissing');
        hideTimer = setTimeout(() => {
          if (!onCta) hide();
          else peek.classList.remove('is-dismissing');
        }, HIDE_FADE_MS);
      };

      tickerBand.addEventListener('pointermove', (e) => {
        const item = e.target.closest('.dd-ticker-item');
        if (!item) { if (current) scheduleHide(); return; }
        if (item !== current) show(item, e.clientX);
        else { clearTimeout(hideTimer); peek.classList.remove('is-dismissing'); anchorTo(item, e.clientX); }
      });
      tickerBand.addEventListener('pointerleave', (e) => {
        const next = e.relatedTarget;
        if (next && (peek === next || peek.contains(next))) return;
        if (pointerInActiveZone(e.clientX, e.clientY)) return;
        scheduleHide();
      });

      document.addEventListener('pointermove', (e) => {
        if (!current) return;
        const item = e.target.closest('.dd-ticker-item');
        const onBtn = e.target === peekCta || peekCta.contains(e.target);
        const onPeek = peek.contains(e.target) || pointerInActiveZone(e.clientX, e.clientY);
        if (item || onBtn || onPeek) {
          clearTimeout(hideTimer);
          peek.classList.remove('is-dismissing');
          if (item) {
            onCta = false;
            if (item !== current) show(item, e.clientX);
            else {
              anchorTo(item, e.clientX, onPeek || onBtn);
              if (!raf) raf = requestAnimationFrame(follow);
            }
          } else {
            onCta = onBtn;
            keepPeekActive(e.clientX, e.clientY);
          }
          return;
        }
        onCta = false;
        scheduleHide();
      }, { passive: true });

      peekCta.addEventListener('pointerenter', () => {
        onCta = true;
        clearTimeout(hideTimer);
        peek.classList.remove('is-dismissing');
      });
      peekCta.addEventListener('pointermove', (e) => {
        if (!current) return;
        onCta = true;
        keepPeekActive(e.clientX, e.clientY);
      });
      peekCta.addEventListener('pointerleave', (e) => {
        onCta = false;
        if (e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('.dd-ticker-item')) return;
        scheduleHide();
      });

      peekCta.addEventListener('pointerdown', (e) => {
        e.stopPropagation();
        onCta = true;
        clearTimeout(hideTimer);
      });
      peekCta.addEventListener('click', (e) => {
        const href = peekCta.getAttribute('href');
        if (!href || href === '#') return;
        e.preventDefault();
        window.location.assign(href);
      });

      window.addEventListener('scroll', () => { if (current) hide(); }, { passive: true });
    }

    const calBase = 'https://calendar.google.com/calendar/render?action=TEMPLATE';
    const where = (document.querySelector('[data-cal-where]') && document.querySelector('[data-cal-where]').dataset.calWhere) || 'PHYLUM, 901 N. Palm Canyon Dr., Palm Springs, CA';
    document.querySelectorAll('.dd-event-copy a, .dd-book-lead a').forEach(a => {
      if (/^https?:/i.test(a.getAttribute('href') || '')) {
        a.target = '_blank';
        a.rel = 'noopener';
      }
    });
    document.querySelectorAll('[data-cal]').forEach(link => {
      const params = new URLSearchParams({
        text: link.dataset.title,
        dates: `${link.dataset.start}/${link.dataset.end}`,
        ctz: 'America/Los_Angeles',
        location: where,
        details: 'A new season at PHYLUM. Desert Dreaming. shopphylum.com'
      });
      link.href = `${calBase}&${params.toString()}`;
      link.target = '_blank';
      link.rel = 'noopener';
      link.insertAdjacentHTML('afterbegin', '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="3.5" y="5" width="17" height="15" rx="1.5"/><path d="M3.5 10h17M8 3v4M16 3v4"/></svg>');
    });

    const countdownNodes = document.querySelectorAll('[data-count]');
    countdownNodes.forEach((countdown) => {
      const campaignStart = Date.parse(countdown.dataset.campaignStart || '2026-10-01T00:00:00-07:00');
      const doneTitle = countdown.dataset.doneTitle || 'Thank you for three years. Shop the pop-up online.';
      let milestoneSource = [
        { title: 'New arrivals in-store and online', when: 'Thu, Oct 15 · 10:00 AM', start: '2026-10-15T10:00:00-07:00' },
        { title: 'Sip into the weekend.', when: 'Fri, Oct 16 · 3:00 - 5:00 PM', start: '2026-10-16T15:00:00-07:00', end: '2026-10-16T17:00:00-07:00' },
        { title: 'Heat wave incoming. The literary kind.', when: 'Sat, Oct 17 · 12:00 - 4:00 PM', start: '2026-10-17T12:00:00-07:00', end: '2026-10-17T16:00:00-07:00' },
        { title: 'Last call for fresh ink.', when: 'Sun, Oct 18 · 12:00 - 4:00 PM', start: '2026-10-18T12:00:00-07:00', end: '2026-10-18T16:00:00-07:00' }
      ];
      const milestoneNode = countdown.querySelector('[data-dd-milestones]');
      if (milestoneNode) {
        try {
          const parsed = JSON.parse(milestoneNode.textContent);
          if (Array.isArray(parsed) && parsed.length) milestoneSource = parsed;
        } catch (e) {}
      }
      const milestones = milestoneSource.map(m => ({ ...m, start: Date.parse(m.start), end: m.end ? Date.parse(m.end) : null }));

      // ?now=2026-10-17T17:00 previews any moment of the campaign for review.
      const previewNow = new URLSearchParams(location.search).get('now');
      const offset = previewNow ? Date.parse(previewNow + (previewNow.length <= 16 ? ':00-07:00' : '')) - Date.now() : 0;

      const el = {
        title: countdown.querySelector('[data-count-title]'),
        when: countdown.querySelector('[data-count-when]'),
        fill: countdown.querySelector('[data-count-fill]'),
        sun: countdown.querySelector('[data-count-sun]'),
        ticks: countdown.querySelectorAll('.dd-count-tick'),
        units: {}
      };
      countdown.querySelectorAll('[data-unit]').forEach(u => { el.units[u.dataset.unit] = u; });

      const setUnit = (key, value) => {
        const node = el.units[key];
        const text = String(value).padStart(2, '0');
        if (node.dataset.v === text) return;
        node.dataset.v = text;
        if (!node.digits || node.digits.length !== text.length) {
          node.textContent = '';
          node.digits = [...text].map(ch => {
            const slot = document.createElement('span');
            slot.className = 'dd-dg';
            slot.appendChild(document.createElement('span')).textContent = ch;
            return node.appendChild(slot);
          });
          return;
        }
        [...text].forEach((ch, i) => {
          const slot = node.digits[i];
          const current = slot.lastElementChild;
          if (current.textContent === ch) return;
          const next = slot.appendChild(document.createElement('span'));
          next.textContent = ch;
          if (reduceMotion) { current.remove(); return; }
          const roll = { duration: 820, easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'both' };
          current.animate([
            { transform: 'translateY(0)', opacity: 1, filter: 'blur(0)' },
            { transform: 'translateY(-55%)', opacity: 0, filter: 'blur(3px)' }
          ], roll).onfinish = () => current.remove();
          next.animate([
            { transform: 'translateY(55%)', opacity: 0, filter: 'blur(3px)' },
            { transform: 'translateY(0)', opacity: 1, filter: 'blur(0)' }
          ], roll);
        });
      };

      const tick = () => {
        const now = Date.now() + offset;
        const live = milestones.find(m => m.end && now >= m.start && now < m.end);
        const nextIndex = milestones.findIndex(m => m.start > now);
        const last = milestones[milestones.length - 1];
        const done = now >= last.end;

        let target;
        if (live) {
          el.title.textContent = `Now · ${live.title}`;
          el.when.textContent = live.when;
          target = live.end;
        } else if (nextIndex !== -1) {
          const next = milestones[nextIndex];
          el.title.textContent = next.title;
          el.when.textContent = next.when;
          target = next.start;
        } else {
          el.title.textContent = done ? doneTitle : last.title;
          el.when.textContent = '';
          target = done ? now : last.end;
        }
        countdown.classList.toggle('is-live', Boolean(live));
        countdown.classList.toggle('is-done', done);

        const left = Math.max(0, target - now);
        setUnit('d', Math.floor(left / 864e5));
        setUnit('h', Math.floor(left / 36e5) % 24);
        setUnit('m', Math.floor(left / 6e4) % 60);
        setUnit('s', Math.floor(left / 1e3) % 60);

        // Each day owns an equal slice of the track so the weekend reads clearly.
        const slice = 100 / milestones.length;
        let progress = 100;
        const seg = milestones.findIndex(m => m.start > now);
        if (seg !== -1) {
          const from = seg === 0 ? campaignStart : milestones[seg - 1].start;
          const frac = Math.min(1, Math.max(0, (now - from) / (milestones[seg].start - from)));
          progress = slice * seg + slice * frac;
        }
        countdown.style.setProperty('--progress', progress.toFixed(3) + '%');
        el.ticks.forEach((t, i) => {
          t.classList.toggle('is-past', Boolean(milestones[i]) && now >= milestones[i].start);
          t.classList.toggle('is-next', i === nextIndex && !live);
        });
      };

      tick();
      setInterval(tick, 1000);
    });

    const fitWelcome = () => {
      document.querySelectorAll('.dd-title').forEach((title) => {
        const main = title.querySelector('.dd-title-main');
        const mainText = main && main.querySelector('span');
        const sub = title.querySelector('.dd-title-sub');
        const subText = sub && sub.querySelector('span');
        if (!main || !mainText || !sub || !subText) return;
        main.style.fontSize = '';
        sub.style.fontSize = '';
        const target = subText.getBoundingClientRect().width;
        if (!target) return;
        let lo = 24;
        let hi = 420;
        for (let i = 0; i < 18; i++) {
          const mid = (lo + hi) / 2;
          main.style.fontSize = mid + 'px';
          if (mainText.getBoundingClientRect().width > target) hi = mid;
          else lo = mid;
        }
        main.style.fontSize = lo + 'px';
        if (!title.closest('.dd-hero--alt')) return;
        const box = title.parentElement.getBoundingClientRect().width;
        const widest = Math.max(mainText.getBoundingClientRect().width, subText.getBoundingClientRect().width);
        if (box && widest > box - 8) {
          const scale = (box - 8) / widest;
          main.style.fontSize = (parseFloat(getComputedStyle(main).fontSize) * scale) + 'px';
          sub.style.fontSize = (parseFloat(getComputedStyle(sub).fontSize) * scale) + 'px';
        }
      });
    };

    const start = () => {
      fitWelcome();
      requestAnimationFrame(() => document.body.classList.add('is-ready'));
    };
    window.addEventListener('resize', fitWelcome);
    if (document.fonts && document.fonts.ready) {
      Promise.race([document.fonts.ready, new Promise(r => setTimeout(r, 1200))]).then(start);
    } else {
      start();
    }

    const stack = [...document.querySelectorAll('.dd-day--stack')];
    let stackFrame = 0;
    const layoutStack = () => {
      const root = document.querySelector('.phylum-dd');
      const stick = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--dd-stick')) || 78;
      const gap = parseFloat(root ? getComputedStyle(root).getPropertyValue('--dd-stack-gap') : '') || 18;
      stack.forEach(card => {
        card.style.marginTop = card.style.marginBottom = '';
        card.classList.remove('is-loose');
        card.style.minHeight = '';
        const index = parseFloat(getComputedStyle(card).getPropertyValue('--i')) || 1;
        const naturalTop = stick + (index - 1) * gap;
        card.style.setProperty('--dd-card-top', `${naturalTop}px`);
      });
      // Each card must stay stuck until the same moment. A taller card
      // otherwise lets go early and slides up behind the cards still stacked on it.
      const limit = Math.max(...stack.map(card => {
        const top = parseFloat(card.style.getPropertyValue('--dd-card-top')) || 0;
        return top + card.offsetHeight;
      }));
      stack.forEach(card => {
        const top = parseFloat(card.style.getPropertyValue('--dd-card-top')) || 0;
        const needed = Math.ceil(limit - top);
        if (needed > card.offsetHeight) card.style.minHeight = `${needed}px`;
      });
      const days = document.querySelector('.dd-days');
      const book = document.querySelector('.dd-book');
      const runwayEl = days ? days.querySelector('.dd-stack-runway') : null;
      if (days) days.style.paddingBottom = '';
      if (runwayEl) runwayEl.style.height = '0';
      if (book) book.style.marginTop = '';
    };
    const renderStack = () => {
      stackFrame = 0;
      stack.forEach(card => {
        const next = card.nextElementSibling;
        if (!next || !next.classList.contains('dd-day--stack')) return;
        const r = card.getBoundingClientRect();
        const n = next.getBoundingClientRect();
        if (!reduceMotion) {
          const cover = Math.min(1, Math.max(0, (r.bottom - n.top) / r.height));
          card.style.setProperty('--cover', cover.toFixed(3));
        }
        // A covered card never shows below the card on top of it.
        const trim = (r.bottom - n.bottom + 2) * (card.offsetHeight / r.height);
        card.style.clipPath = trim > 0 && n.top < r.bottom
          ? `inset(0 0 ${trim.toFixed(1)}px 0 round ${getComputedStyle(card).borderTopLeftRadius})`
          : '';
      });
    };
    const queueStack = () => { if (!stackFrame) stackFrame = requestAnimationFrame(renderStack); };
    window.addEventListener('scroll', queueStack, { passive: true });
    window.addEventListener('resize', () => { layoutStack(); queueStack(); });
    window.addEventListener('load', () => { layoutStack(); renderStack(); });
    layoutStack();
    renderStack();

    const reveals = document.querySelectorAll('.dd-reveal');
    if ('IntersectionObserver' in window && !reduceMotion) {
      const io = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
      reveals.forEach(el => io.observe(el));
    } else {
      reveals.forEach(el => el.classList.add('is-in'));
    }

    if (reduceMotion) return;

  })();
}
